export class BaseProvider {

	static formatPrice(price, currencyId) {
		var p = parseFloat(price);
		if (isNaN(p)) return '';
		return p.toFixed(2) + ' ' + BaseProvider.getCurrencySymbol(currencyId);
	}

	static applyServerFormValidation(actions, error) {
		actions.setFieldError('general', error.msg);
		if (error.modelState) {
			for (var prop in error.modelState) {
				if (error.modelState[prop].errors && error.modelState[prop].errors.length > 0) {
					actions.setFieldError(prop, error.modelState[prop].errors[0].errorMessage);
				}
			}
		}
	}
}